import { animate, style, transition, trigger } from "@angular/animations";
import { Component, OnInit, Output, Input, EventEmitter } from "@angular/core";

// Local services
import { AlertService } from "../../services/alert.service";
import { ClienteService } from "../../services/cliente.service";
import { CommonUtilitiesService } from "../../services/common-utilities.service";
import swal from "sweetalert2";
import { NgxPermissionsService } from "ngx-permissions";
import { NgxUiLoaderService } from "ngx-ui-loader";

@Component({
  selector: 'app-gestiones-sidebar-precas-ab',
  templateUrl: './gestiones-sidebar-precas-ab.component.html',
  styleUrls: ['./gestiones-sidebar-precas-ab.component.scss'],
  animations:[
    trigger("inOutAnimation", [
      transition(":enter", [
        style({ height: 0, opacity: 0 }),
        animate("0.3s ease-out", style({ height: 300, opacity: 1 })),
      ]),
      transition(":leave", [
        style({ height: 300, opacity: 1 }),
        animate("0.3s ease-in", style({ height: 0, opacity: 0 })),
      ]),
    ]),
  ]
})
export class GestionesSidebarPrecasABComponent implements OnInit {
  @Output() selecttab = new EventEmitter<number>();
  @Output() selectgestion = new EventEmitter<any>();
  @Output() setDataCliente = new EventEmitter<any>();
  @Output() showDpiAndProductModal = new EventEmitter<any>();

  p = 1;
  itemsPerPage = 10;
  enabled =1 ;
  formContainerWidth = 570;
  term = "";
  precalificaiones=[]
  cunterRefresh=0
  constructor(private alertService: AlertService,
    private loaderService: NgxUiLoaderService,
    private ngxPermissionService: NgxPermissionsService,
    private utilitiesService: CommonUtilitiesService,
    public clienteservice: ClienteService,
    ) { 
        this.setDataPrecas();
    }

  ngOnInit(): void {
  }
  setDataPrecas(){
    this.clienteservice.consultaPrecalificacionPorAbf().then(result=>{
      this.loaderService.stopLoader('loader-global', 'loadingDashboard');
      if(result.error.codigoError=='0'){
        this.precalificaiones=result.abf.filter(i=>i.estadoColorPrecalificacion!='SIN_COLOR'&&i.canalOrigen=='AGENTESBANCARIOS')
      }
    }).catch(error=>{
      this.loaderService.stopLoader('loader-global', 'loadingDashboard');
    })
  }
  OpenClose() {
    this.enabled = this.enabled === 1 ? 0 : 1;
    this.enabled === 1
      ? (this.formContainerWidth = 500)
      : (this.formContainerWidth = 0);
  }
  setGestion(gestion) {
    const testDetailPermission =
      this.ngxPermissionService.getPermission("detalleEvaluacion");
    if (testDetailPermission) {
      this.loaderService.startLoader("loader-global", "loadingDashboard");
      this.selectgestion.emit(gestion);
    } else {
      this.alertService.show(
        "Nota",
        "No tienes permiso para acceder a este módulo"
      );
    }
  }
  showDpiAlert() {
    this.selectedtab(0);
    this.OpenClose();
    this.showDpiAndProductModal.emit({pageOrigin:'sidebarPrecas'})
  }
  selectedtab(tab) {
    this.selecttab.emit(tab);
  }
}
